import classnames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const ExpandableIcon = ({
  className,
  isOpen,
  style
}) => {
  const classes = classnames(["h-6 w-6 inline"], {
    "transform rotate-180": isOpen
  }, className);
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "currentColor",
    className: classes,
    style: style
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
};
ExpandableIcon.propTypes = {
  className: PropTypes.any,
  style: PropTypes.any,
  isOpen: PropTypes.bool
};